import styled from 'styled-components'
import BookedLabel from 'tripPlanner/components/BookedLabel'
import SolidCheckCircleIcon from 'LuxKit/Icons/solid/SolidCheckCircleIcon'
import { setSvgIconSize } from 'LuxKit/SvgIcon'

/** Displays when the card's content area is at least 640px wide */
export const WideCardOnlyBookedLabel = styled(BookedLabel)`
  display: none;

  @container (min-width: 640px) {
    display: inline-flex;
  }
`

/** Displays when the card's content area is less than 640px wide */
export const NarrowCardOnlyBookedLabel = styled(SolidCheckCircleIcon)`
  display: inline-flex;
  ${setSvgIconSize(16)};
  color: ${props => props.theme.palette.highlight.secondary.normalForeground};

  @container (min-width: 640px) {
    display: none;
  }
`
